import * as Yup from "yup";
import moment from "moment";

export const periodicBillingReportInitialValues = {
  merchant_id: "",
  start_date: "",
  end_date: "",
  status: "",
};

// Calcular fechas límite usando moment
const today = moment();
const ninetyDaysAgo = moment().subtract(90, "days");

const todayString = today.format("YYYY-MM-DD");
const ninetyDaysAgoString = ninetyDaysAgo.format("YYYY-MM-DD");

// Función helper para convertir YYYYMMDD a moment
const parseDate = (value) => {
  if (!value) return null;

  if (value.match(/^\d{8}$/)) {
    // Formato: YYYYMMDD -> moment
    return moment(value, "YYYYMMDD");
  }

  // Intentar parsear como fecha estándar
  return moment(value);
};

// Función helper para validar rango de fechas
const validateDateRange = (value, fieldName) => {
  const date = parseDate(value);
  if (!date || !date.isValid()) return false;

  const today = moment();
  const ninetyDaysAgo = moment().subtract(90, "days");

  const isValid = date.isBetween(ninetyDaysAgo, today, "day", "[]");

  return isValid;
};

export const periodicBillingReportValidationSchema = Yup.object().shape({
  merchant_id: Yup.string().required("Merchant ID is required"),
  start_date: Yup.string()
    .required("Start Date is required")
    .test(
      "date-range",
      `Start date must be between ${ninetyDaysAgoString} and ${todayString}`,
      function (value) {
        return validateDateRange(value, "Start Date");
      }
    ),
  end_date: Yup.string()
    .required("End Date is required")
    .test(
      "date-range",
      `End date must be between ${ninetyDaysAgoString} and ${todayString}`,
      function (value) {
        return validateDateRange(value, "End Date");
      }
    )
    .test(
      "end-after-start",
      "End date must be after or equal to start date",
      function (value) {
        const { start_date } = this.parent;
        if (!value || !start_date) return true;

        const startDate = parseDate(start_date);
        const endDate = parseDate(value);

        if (
          !startDate ||
          !endDate ||
          !startDate.isValid() ||
          !endDate.isValid()
        ) {
          return true; // Dejar que otras validaciones manejen los errores
        }

        return endDate.isSameOrAfter(startDate, "day");
      }
    ),
  status: Yup.string()
    .nullable()
    .oneOf(["P", "E", "C", ""], "Status must be P (Pending), E (Executed), or C (Canceled)"),
});

